"use client"

import { Link } from "@/i18n/routing"
import type { MainNavItem } from "@/types"

import { cn } from "@/lib/utils"
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu"
import { Icons } from "@/components/icons"

import { ListItem } from "../ui/list-item"

export interface MainNavProps {
  items?: MainNavItem[]
}

export function MainNav({ items }: MainNavProps) {
  const renderMenuItem = (item: MainNavItem) => {
    if (item.items && item.items.length > 0) {
      // Regular menu with subcategories
      return (
        <NavigationMenuItem key={item.title}>
          <NavigationMenuTrigger className="h-auto capitalize">
            {item.title}
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
              {item.items.map((subItem) => (
                <ListItem
                  key={subItem.title}
                  title={subItem.title}
                  href={subItem.href}
                >
                  {subItem.description}
                </ListItem>
              ))}
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      )
    } else {
      // No Megamenu or Mega menu but no Subcategories
      return (
        <NavigationMenuItem key={item.title}>
          <NavigationMenuLink
            href={item.href}
            className={cn(navigationMenuTriggerStyle(), "h-auto")}
          >
            {item.title}
          </NavigationMenuLink>
        </NavigationMenuItem>
      )
    }
  }

  return (
    <div className="hidden gap-10 lg:flex">
      <Link href="/" className="hidden items-center space-x-2 lg:flex">
        <Icons.logo
          className="w-32 p-0.5 text-accent-foreground"
          aria-hidden="true"
        />
        <span className="sr-only">Home</span>
      </Link>
      <NavigationMenu>
        <NavigationMenuList>
          {items?.map((item) => renderMenuItem(item))}
        </NavigationMenuList>
        {/* <LocaleSwitcher /> */}
      </NavigationMenu>
    </div>
  )
}
